import { render } from "./DeleteConfirmationModal.vue?vue&type=template&id=7a6b3484"
import script from "./DeleteConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirmationModal.vue?vue&type=script&lang=ts"
script.render = render

export default script